<template>
	<div>
		<teleport to="body">
			<transition name="fade">
				<div class="modal__overlay" v-if="open" @click="handleClose"></div>
			</transition>
			<transition name="modal" @after-leave="handleTransitionEnd">
				<div class="modal" v-if="open" :class="{open}" ref="modal" tabindex="-1" aria-hidden="true" data-scroll-lock-scrollable>
					<div class="modal__dialog modal--dialog-centered" :class="dialogClass">
						<div class="modal__content">
							<div class="modal__header" v-if="title">
								<h4 class="modal__title">{{title}}</h4>
							</div>
							<button type="button" class="modal__close" @click="handleClose" aria-label="Close" ref="Close">
								<span aria-hidden="true" class="modal__close-icon">&times;</span>
							</button>
							<div class="modal__body">
								<slot></slot>
							</div>
						</div>
					</div>
				</div>
			</transition>
		</teleport>
	</div>
</template>

<script>

import scrollLock from 'scroll-lock';

export default {

	emits: [
		'close'
	],

	props: {
		data: {
			type: Object,
			default: null
		},

		openState: {
			type: Boolean,
			default: false
		},

		title: {
			type: String,
			default: null
		},

		dialogClass: {
			type: String,
			default: null
		}
	},

	data() {
		return {
			open: false
		}
	},

	mounted() {
		if (this.openState) this.open = this.openState;
	},

	watch: {
		open(state) {
			if (state) {
				scrollLock.disablePageScroll(this.$refs.modal);
			} else {
				setTimeout(() => {
					scrollLock.enablePageScroll(this.$refs.modal);
				}, 300);
			}
		},

		openState(state) {
			this.open = state;
		}
	},

	methods: {
		handleClose() {
			this.open = false;
		},

		handleTransitionEnd() {
			if (!this.open) {
				this.$emit('close')
			}
		}
	},

	beforeUnmount() {
		setTimeout(() => {
			scrollLock.enablePageScroll(this.$refs.modal);
		}, 300);
	}
}

</script>